<div fxLayout="column">
    <form *hasPermission="BcmUserPermission.ASSETS_READ" name="settingsForm" novalidate class="settings w-100-p" fxLayout="column"
          (ngSubmit)="false"
          fxFlex
          data-test="C-Verbandsmeldung">

        <div class="fuse-card auto-width">

            <div class="p-16"
                 fxLayout="column" fxLayoutAlign="center stretch"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

                <div fxLayout="row" fxLayoutAlign="start center">

                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="h2">
                            {{ 'settings.defaultUnits.title' | translate }}
                        </div>
                        <div class="subtitle secondary-text">
                            {{ 'settings.defaultUnits.intro' | translate }}
                        </div>
                    </div>

                </div>

                <ng-template #saving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.saving' | translate }}</span>
                    <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                </ng-template>

                <ng-template #notSaving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.save' | translate }}</span>
                </ng-template>

                <button data-test="B-Speichern" mat-flat-button
                        color="accent"
                        [disabled]="!canManageSettings || (bcmSettingsFacade.isUpdating$ | async) || !formsDirty"
                        (click)="$event.stopPropagation(); save($event)">
                    <ng-container
                            *ngIf="(bcmSettingsFacade.isUpdating$ | async); then saving else notSaving"></ng-container>
                </button>

            </div>

            <mat-divider class="my-24"></mat-divider>

            <div class="p-16">

                <div fxLayout="row wrap"
                     fxLayout.lt-sm="column"
                     fxLayoutGap="16px grid"
                     fxLayoutGap.lt-sm="0px"
                     [formGroup]="formGroup">

                    <div fxFlex="60">
                        <h4>
                            {{ 'settings.defaultUnits.dayGuestRelation' | translate }}
                        </h4>
                    </div>

                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-select formControlName="dayGuestBoater">
                            <ng-container *ngFor="let tenantRelation of tenantRelations">
                                <ng-container *ngIf="!tenantRelations?.length">
                                    <mat-option disabled class="loading">
                                        <mat-spinner diameter="35"></mat-spinner>
                                    </mat-option>
                                </ng-container>
                                <mat-option [value]="tenantRelation.id">
                                    {{ tenantRelation.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                </div>

                <mat-divider class="my-24"></mat-divider>

                <div fxLayout="row wrap"
                     fxLayout.lt-sm="column"
                     fxLayoutGap="16px grid"
                     fxLayoutGap.lt-sm="0px"
                     [formGroup]="electricMeterFormGroup">

                    <div fxFlex="60">
                        <h4>
                            {{ 'settings.defaultUnits.electricProductsTitle' | translate }}
                        </h4>
                    </div>

                    <div fxFlex="40" fxLayout="column">
                        <div fxLayout="column" fxLayoutGap="4px">
                            <h5>{{ 'settings.defaultUnits.flatrateProduct' | translate }}</h5>
                            <mat-form-field appearance="outline">
                                <mat-select formControlName="flatrateProductId">
                                    <mat-option [value]="9999999">
                                        <span>{{ 'settings.defaultUnits.noProductSelected' | translate }}</span>
                                    </mat-option>
                                    <ng-container *ngFor="let product of products">
                                        <ng-container *ngIf="!products?.length">
                                            <mat-option disabled class="loading">
                                                <mat-spinner diameter="35"></mat-spinner>
                                            </mat-option>
                                        </ng-container>
                                        <mat-option [value]="product.id">
                                            <span>{{ product.name }}</span>
                                            <small> | {{ product.price | bcmDynamicCurrency :'1.2-4' }}</small>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxLayout="column" fxLayoutGap="6px">
                            <h5>{{ 'settings.defaultUnits.prepaidProduct' | translate }}</h5>
                            <mat-form-field appearance="outline">
                                <mat-select formControlName="prepaidProductId">
                                    <mat-option [value]="9999999">
                                        <span>{{ 'settings.defaultUnits.noProductSelected' | translate }}</span>
                                    </mat-option>
                                    <ng-container *ngFor="let product of products">
                                        <ng-container *ngIf="!products?.length">
                                            <mat-option disabled class="loading">
                                                <mat-spinner diameter="35"></mat-spinner>
                                            </mat-option>
                                        </ng-container>
                                        <mat-option [value]="product.id">
                                            <span>{{ product.name }}</span>
                                            <small> | {{ product.price | bcmDynamicCurrency :'1.2-4' }}</small>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxLayout="column" fxLayoutGap="6px">
                            <h5>{{ 'settings.defaultUnits.usageProduct' | translate }}</h5>
                            <mat-form-field appearance="outline">
                                <mat-select formControlName="usageProductId">
                                    <mat-option [value]="9999999">
                                        <span>{{ 'settings.defaultUnits.noProductSelected' | translate }}</span>
                                    </mat-option>
                                    <ng-container *ngFor="let product of products">
                                        <ng-container *ngIf="!products?.length">
                                            <mat-option disabled class="loading">
                                                <mat-spinner diameter="35"></mat-spinner>
                                            </mat-option>
                                        </ng-container>
                                        <mat-option [value]="product.id">
                                            <span>{{ product.name }}</span>
                                            <small> | {{ product.price | bcmDynamicCurrency :'1.2-4' }}</small>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>


                <mat-divider class="my-24"></mat-divider>

                <div fxLayout="row wrap"
                     fxLayout.lt-sm="column"
                     fxLayoutGap="16px grid"
                     fxLayoutGap.lt-sm="0px">

                    <div fxFlex="60">
                        <h4>
                            {{ 'settings.defaultUnits.bookingDefaultTitle' | translate }}
                        </h4>
                    </div>

                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-select [formControl]="bookingTypeFormControl">
                            <mat-option [value]="BookingType.Reservation">
                                <span>{{ 'settings.defaultUnits.reservation' | translate }}</span>
                            </mat-option>
                            <mat-option [value]="BookingType.Booking">
                                <span>{{ 'settings.defaultUnits.booking' | translate }}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>

                <mat-divider class="my-24"></mat-divider>

                <div fxLayout="row wrap"
                     fxLayout.lt-sm="column"
                     fxLayoutGap="16px grid"
                     fxLayoutGap.lt-sm="0px"
                     [formGroup]="timeFormGroup">

                    <div fxFlex="60">
                        <h4>
                            {{ 'settings.defaultUnits.berthUnitTitle' | translate }}
                        </h4>
                    </div>

                    <div fxFlex="40">
                        <mat-radio-group formControlName="type" fxLayout="column">
                            <mat-radio-button [value]="DEFAULT_BERTH_RESERVATION_UNIT.NONE">
                                {{ 'settings.defaultUnits.unitInactive' | translate }}
                            </mat-radio-button>
                            <mat-radio-button [value]="DEFAULT_BERTH_RESERVATION_UNIT.DAY">
                                {{ 'settings.defaultUnits.unitDay' | translate }}
                            </mat-radio-button>
                            <mat-radio-button [value]="DEFAULT_BERTH_RESERVATION_UNIT.OVERNIGHT_STAY">
                                {{ 'settings.defaultUnits.unitOvernight' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!--                    <div fxFlex="60">-->
                    <!--                    </div>-->

                    <!--                    <div fxFlex="40" class="mt-8">-->
                    <!--                        <div fxFlex="45">-->
                    <!--                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">-->
                    <!--                                <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>-->
                    <!--                                <mat-select data-test="FS-Std"-->
                    <!--                                            formControlName="fromHours">-->
                    <!--                                    <mat-option *ngFor="let hour of hours" [value]="hour">-->
                    <!--                                        {{hour}}-->
                    <!--                                    </mat-option>-->
                    <!--                                </mat-select>-->
                    <!--                                <mat-error>{{timeFormGroup.get('fromHours').errors | firstErrorMessage}}</mat-error>-->
                    <!--                            </mat-form-field>-->
                    <!--                            <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>-->
                    <!--                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">-->
                    <!--                                <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>-->
                    <!--                                <mat-select data-test="FS-Std"-->
                    <!--                                            formControlName="fromMinutes">-->
                    <!--                                    <mat-option *ngFor="let minute of minutes" [value]="minute">-->
                    <!--                                        {{minute}}-->
                    <!--                                    </mat-option>-->
                    <!--                                </mat-select>-->
                    <!--                                <mat-error>{{timeFormGroup.get('fromMinutes').errors | firstErrorMessage}}</mat-error>-->
                    <!--                            </mat-form-field>-->

                    <!--                        </div>-->

                    <!--                        <div fxFlex="10" fxLayoutAlign="center" fxFlexAlign="center">{{ 'settings.labels.until' | translate }}</div>-->

                    <!--                        <div fxFlex="45">-->
                    <!--                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">-->
                    <!--                                <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>-->
                    <!--                                <mat-select data-test="FS-Std"-->
                    <!--                                            formControlName="toHours">-->
                    <!--                                    <mat-option *ngFor="let hour of hours" [value]="hour">-->
                    <!--                                        {{hour}}-->
                    <!--                                    </mat-option>-->
                    <!--                                </mat-select>-->
                    <!--                                <mat-error>{{timeFormGroup.get('toHours').errors | firstErrorMessage}}</mat-error>-->
                    <!--                            </mat-form-field>-->
                    <!--                            <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>-->
                    <!--                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">-->
                    <!--                                <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>-->
                    <!--                                <mat-select data-test="FS-Std"-->
                    <!--                                            formControlName="toMinutes">-->
                    <!--                                    <mat-option *ngFor="let minute of minutes" [value]="minute">-->
                    <!--                                        {{minute}}-->
                    <!--                                    </mat-option>-->
                    <!--                                </mat-select>-->
                    <!--                                <mat-error>{{timeFormGroup.get('toMinutes').errors | firstErrorMessage}}</mat-error>-->
                    <!--                            </mat-form-field>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <mat-divider fxFlex="100" class="my-24"></mat-divider>

                    <div fxFlex="60">
                        <h4>{{ 'settings.defaultUnits.useDayBookings.label' | translate }}</h4>
                        <p class="hint-text"
                           [innerHTML]="'settings.defaultUnits.useDayBookings.description' | translate">
                        </p>
                    </div>
                    <div fxFlex="40">
                        <mat-slide-toggle formControlName="useDayBookings"
                                          data-test="FS-UseDayBookings">
                            {{ 'settings.defaultUnits.useDayBookings.toggleLabel' | translate }}
                        </mat-slide-toggle>
                    </div>

                    <mat-divider fxFlex="100" class="my-24"></mat-divider>

                    <ng-container *ngIf="dayBookingsEnabled">
                        <div fxFlex="60">
                            <h4 [innerHTML]="'settings.defaultUnits.checkInOutOneDay' | translate">
                            </h4>
                        </div>
                        <div fxFlex="40">
                            <div fxFlex="45">
                                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                    <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>
                                    <mat-select data-test="FS-Std"
                                                formControlName="dailyGuestFromHours">
                                        <mat-option *ngFor="let hour of hours" [value]="hour">
                                            {{ hour }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>{{ timeFormGroup.get('dailyGuestFromHours').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>
                                <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>
                                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                    <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>
                                    <mat-select data-test="FS-Std"
                                                formControlName="dailyGuestFromMinutes">
                                        <mat-option *ngFor="let minute of minutes" [value]="minute">
                                            {{ minute }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>{{ timeFormGroup.get('dailyGuestFromMinutes').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>

                            </div>

                            <div fxFlex="10" fxLayoutAlign="center" fxFlexAlign="center">{{ 'settings.labels.until' | translate }}</div>

                            <div fxFlex="45">
                                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                    <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>
                                    <mat-select data-test="FS-Std"
                                                formControlName="dailyGuestToHours">
                                        <mat-option *ngFor="let hour of hours" [value]="hour">
                                            {{ hour }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>{{ timeFormGroup.get('dailyGuestToHours').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>
                                <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>
                                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                    <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>
                                    <mat-select data-test="FS-Std"
                                                formControlName="dailyGuestToMinutes">
                                        <mat-option *ngFor="let minute of minutes" [value]="minute">
                                            {{ minute }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>{{ timeFormGroup.get('dailyGuestToMinutes').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>

                    <div fxFlex="60">
                        <h4 [innerHTML]="'settings.defaultUnits.checkInOutMultiDay' | translate">
                        </h4>
                    </div>
                    <div fxFlex="40">
                        <div fxFlex="45">
                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>
                                <mat-select data-test="FS-Std"
                                            formControlName="overnightGuestFromHours">
                                    <mat-option *ngFor="let hour of hours" [value]="hour">
                                        {{ hour }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{ timeFormGroup.get('overnightGuestFromHours').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>
                            <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>
                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>
                                <mat-select data-test="FS-Std"
                                            formControlName="overnightGuestFromMinutes">
                                    <mat-option *ngFor="let minute of minutes" [value]="minute">
                                        {{ minute }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{ timeFormGroup.get('overnightGuestFromMinutes').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>

                        </div>

                        <div fxFlex="10" fxLayoutAlign="center" fxFlexAlign="center">{{ 'settings.labels.until' | translate }}</div>

                        <div fxFlex="45">
                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                <mat-label>{{ 'settings.labels.hour' | translate }}</mat-label>
                                <mat-select data-test="FS-Std"
                                            formControlName="overnightGuestToHours">
                                    <mat-option *ngFor="let hour of hours" [value]="hour">
                                        {{ hour }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{ timeFormGroup.get('overnightGuestToHours').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>
                            <div fxFlex="2" fxLayoutAlign="center" fxFlexAlign="center">:</div>
                            <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                                <mat-label>{{ 'settings.labels.minute' | translate }}</mat-label>
                                <mat-select data-test="FS-Std"
                                            formControlName="overnightGuestToMinutes">
                                    <mat-option *ngFor="let minute of minutes" [value]="minute">
                                        {{ minute }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{ timeFormGroup.get('overnightGuestToMinutes').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <mat-divider class="my-24"></mat-divider>

                <div fxLayout="row wrap"
                     fxLayout.lt-sm="column"
                     fxLayoutGap="16px grid"
                     fxLayoutGap.lt-sm="0px" *hasTenantPermission="bcmTenantPermissions.PIN_CODES">

                    <div fxFlex="60">
                        <h4>
                            {{ 'settings.defaultUnits.pinCodeFormatTitle' | translate }}
                        </h4>
                    </div>

                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-label>{{ 'settings.labels.standardFormat' | translate }}</mat-label>
                        <input matInput type="text"
                               [formControl]="pinCodeMaskFormControl">
                        <mat-error>{{pinCodeMaskFormControl.errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>

                </div>

            </div>
        </div>
    </form>

    <inline-edit-table
            *hasPermission="BcmUserPermission.ASSETS_READ"
            titleKey="settings.defaultUnits.assetTemplatesTitle"
            introKey="settings.defaultUnits.assetTemplatesIntro"
            saveTooltipKey="settings.defaultUnits.tooltipSaveAsset"
            cancelTooltipKey="settings.defaultUnits.tooltipCancelAsset"
            addLabelKey="settings.defaultUnits.saveAssetTemplate"
            addTestId="B-Asset Vorlage speichern"
            rowTestIdPrefix="TZ-Asset-Vorlage-"
            removeTitleKey="settings.defaultUnits.removeAssetTitle"
            [rows]="defaultAssets"
            [columns]="assetColumns"
            [canWrite]="canAssetWrite"
            [canDelete]="canAssetDelete"
            [add]="addAsset"
            [save]="saveAsset"
            [remove]="removeAsset">
    </inline-edit-table>

    <berth-categories *hasPermission="BcmUserPermission.BERTHS_READ"></berth-categories>
</div>
